import Navbar from 'application/header/navbar';
import { getCurrentNavbarMenu } from 'application/header/navbar/redux/actions';
import { NavbarState } from 'application/header/navbar/redux/types';
import { Component, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import SettingsComponent from './_settings/settings-container';
import ActivityLogContainer from './activity-log';
import ChannelsContainer from './channels';
import './device-detail-styles.scss';
import DvrContainer from './dvr';
import DeviceHardDiskContainer from './hard-disk/device-hard-disk-container';
import DeviceChecks from './monitoring/device-checks';
import WifiDashboards from './monitoring/wifi-dashboard';
import DeviceDetailOverviewContainer from './overview/device-detail-overview-container';
import ProvisionedDevicesContainer from './provisioned-devices';
import RfTuningContainer from './rf-tuning';
import SpeedTestContainer from './speed-test';
import SubscriptionsContainer from './subscriptions';
import VodContainer from './vod';

type HoCDeviceDetailProps = {
  openModal: any;
  closeModal: any;
  navbar: NavbarState;
  resetFilter: () => void;
}

type DeviceDetailProps = HoCDeviceDetailProps & {
  id: string;
  hhid: string;
  serialNr: string;
  currentPage: string;
}

export default function HoCDeviceDetailComponent(props: HoCDeviceDetailProps) {
  const params = useParams()
  return <DeviceDetailComponent {...props}
    id={params.id}
    hhid={params.hhid}
    serialNr={params.serialNr}
    currentPage={params.type}
  />
}
class DeviceDetailComponent extends Component<DeviceDetailProps> {
  componentWillUnmount(): void {
    this.props.resetFilter()
  }

  render() {
    const { currentPage } = this.props;
    const nav = this.props.navbar.navbar.get('device');
    
    return (
      <Fragment>
        <Navbar
          hhid={this.props.hhid}
          id={this.props.id}
          serialNr={this.props.serialNr}
          currentPage={currentPage}
        />
        <div className="section has-margin-bottom-lg">
          <div className="tile is-ancestor flex-wrap">
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'overview' && (
              <DeviceDetailOverviewContainer hhid={this.props.hhid} id={this.props.id} serialNr={this.props.serialNr}/>
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'provisioned_devices' && (
              <ProvisionedDevicesContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'subscriptions' && (
              <SubscriptionsContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'rf_tuning' && (
              <RfTuningContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'channels' && (
              <ChannelsContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'speed_test' && (
              <SpeedTestContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'dvr' && (
              <DvrContainer
                hhid={this.props.hhid}
                id={this.props.id}
                serialNr={this.props.serialNr}
              />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'hard_disk' && (
              <DeviceHardDiskContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'vod' && (
              <VodContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'activity_log' && (
              <ActivityLogContainer hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'settings' && (
              <SettingsComponent hhid={this.props.hhid} id={this.props.id} />
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'device_checks' && (
              <DeviceChecks id={this.props.id}/>
            )}
            {nav && getCurrentNavbarMenu(nav.current, currentPage) === 'wifi_dashboards' && (
              <WifiDashboards id={this.props.id}/>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
